import { render, staticRenderFns } from "./krSchoolForm.vue?vue&type=template&id=70380a16&scoped=true&"
import script from "./krSchoolForm.vue?vue&type=script&lang=js&"
export * from "./krSchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./krSchoolForm.vue?vue&type=style&index=0&id=70380a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70380a16",
  null
  
)

export default component.exports